export class SweetFaceTransactionDto {
  id: number;
  slipnumber: number;
  bankTerminalId: string;
  bankMID: string;
  currency: string;
  bankTransactionId: string;
  transactionTypeName: string;
  transactionDateTime: string;
  transactionAmount: number;
  approvalCode: string;
  giftCardId: string;
  refOriginalTransactionId: string;
  refunded: number;
  settled: boolean;
  cardPreauthCompleted: number;
  terminalId: number;
  terminalName: string;
  pieMerchantId: number;
  pieCurrency?: {
    currencyId: number;
    currencyCode: string;
    currencySymbol: string;
  }
}